import type { User } from '@shared'
import { atomStateGenerator } from '@/core/'

export const {
  atom: userDataStateAtom,
  useValue: useUserDataValue,
  useState: useUserDataState,
  useReset: useUserDataReset,
} = atomStateGenerator<User | undefined>({
  key: 'userDataState',
  defaultValue: undefined,
  persist: true,
})
